import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { z } from 'zod/v4'

import type { GetAdminUsersResponse } from '../../types/admin-user.js'

import { apiClient } from '../../lib/client.js'
import { adminKeys } from './keys.js'

export type GetAdminUsersQueryItem = GetAdminUsersResponse[number]

export const getAdminsParamsSchema = z.object({
  excludePlanningExcluded: z.boolean().optional(),
  fuzzy: z.string().optional(),
})

export type GetAdminsQueryParamsType = z.infer<typeof getAdminsParamsSchema>

export const useGetAdminsQuery = (params: GetAdminsQueryParamsType) =>
  useQuery({
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const response = await apiClient.client.get<GetAdminUsersResponse>('/admin-user', {
        params,
      })
      return response.data
    },
    queryKey: adminKeys.filtered(params),
  })
